import { useRef, useEffect, useState } from 'react'
import { Tip, SearchIcon } from '@ofself/shell'
import EMOJI_NAMES from '../utils/emojiNames'

function PickerEmoji({ emoji, onClick }) {
  return <button type="button" className="emoji-picker__item" onClick={onClick}>{emoji}</button>
}

function Section({ title, emojis, onPick }) {
  return (
    <section>
      <h3 className="emoji-picker__title text-kicker">{title}</h3>
      <div className="emoji-picker__grid">
        {emojis.map((emoji) => <PickerEmoji key={emoji} emoji={emoji} onClick={() => onPick(emoji)} />)}
      </div>
    </section>
  )
}

const EMOJI_CATEGORIES = {
  'Smileys & People': [
    '😀','😃','😄','😁','😆','😅','🤣','😂','🙂','😊',
    '😇','🥰','😍','🤩','😘','😗','😚','😙','🥲','😋',
    '😛','😜','🤪','😝','🤑','🤗','🤭','🫢','🤫','🤔',
    '🫡','🤐','🤨','😐','😑','😶','🫠','😏','😒','🙄',
    '😬','😮‍💨','🤥','🫨','😌','😔','😪','🤤','😴','😷',
    '🤒','🤕','🤢','🤮','🥵','🥶','🥴','😵','🤯','🤠',
    '🥳','🥸','😎','🤓','🧐','😕','🫤','😟','🙁','😮',
    '😯','😲','😳','🥺','🥹','😦','😧','😨','😰','😥',
    '😢','😭','😱','😖','😣','😞','😓','😩','😫','🥱',
    '😤','😡','😠','🤬','😈','👿','💀','☠️','💩','🤡',
    '👹','👺','👻','👽','👾','🤖',
  ],
  'Gestures & People': [
    '👋','🤚','🖐️','✋','🖖','🫱','🫲','🫳','🫴','👌',
    '🤌','🤏','✌️','🤞','🫰','🤟','🤘','🤙','👈','👉',
    '👆','🖕','👇','☝️','🫵','👍','👎','✊','👊','🤛',
    '🤜','👏','🙌','🫶','👐','🤲','🤝','🙏','💪','🦾',
  ],
  'Animals & Nature': [
    '🐶','🐱','🐭','🐹','🐰','🦊','🐻','🐼','🐨','🐯',
    '🦁','🐮','🐷','🐸','🐵','🐔','🐧','🐦','🦆','🦅',
    '🦉','🦇','🐺','🐗','🐴','🦄','🐝','🪱','🐛','🦋',
    '🐌','🐞','🐜','🪰','🪲','🪳','🌸','💐','🌷','🌹',
    '🌻','🌺','🌵','🌲','🌳','🍀','🍁','🍂','🍃','🪴',
  ],
  'Food & Drink': [
    '🍎','🍐','🍊','🍋','🍌','🍉','🍇','🍓','🫐','🍈',
    '🍒','🍑','🥭','🍍','🥝','🍅','🥑','🍕','🍔','🍟',
    '🌭','🍿','🧂','🥚','🍳','🧈','🥞','🧇','🥓','🍖',
    '☕','🍵','🧃','🥤','🍺','🍻','🥂','🍷','🍸','🍹',
  ],
  'Activities': [
    '⚽','🏀','🏈','⚾','🥎','🎾','🏐','🏉','🥏','🎱',
    '🏓','🏸','🏒','🥅','⛳','🏹','🎣','🤿','🥊','🥋',
    '🎯','🎮','🕹️','🎲','🧩','🎭','🎨','🎤','🎧','🎵',
  ],
  'Travel & Places': [
    '🚗','🚕','🚌','🚎','🏎️','🚓','🚑','🚒','🚐','🛻',
    '🚚','🚛','🚜','✈️','🚀','🛸','🚁','⛵','🚢','🏠',
    '🏡','🏢','🏗️','🌍','🌎','🌏','🗺️','🧭','🏔️','⛰️',
  ],
  'Objects': [
    '⌚','📱','💻','⌨️','🖥️','🖨️','🖱️','💾','💿','📷',
    '📹','🎥','📞','☎️','📺','📻','🔔','🔕','📢','📣',
    '💡','🔦','🕯️','📦','🔧','🔨','🔩','🪛','📎','📌',
  ],
  'Symbols': [
    '❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔',
    '❤️‍🔥','💕','💞','💓','💗','💖','💘','💝','✨','⭐',
    '🌟','💫','🔥','💯','✅','❌','⚠️','🚫','♻️','💤',
  ],
  'Flags': [
    '🏳️','🏴','🏁','🚩','🏳️‍🌈','🏳️‍⚧️','🇺🇸','🇬🇧','🇫🇷','🇩🇪',
    '🇯🇵','🇰🇷','🇨🇳','🇮🇳','🇧🇷','🇲🇽','🇨🇦','🇦🇺','🇮🇹','🇪🇸',
  ],
}

const CATEGORY_ICONS = {
  'Smileys & People': '😊',
  'Gestures & People': '👋',
  'Animals & Nature': '🐶',
  'Food & Drink': '🍔',
  'Activities': '⚽',
  'Travel & Places': '🚗',
  'Objects': '💡',
  'Symbols': '❤️',
  'Flags': '🏁',
}

const FREQUENTLY_USED_KEY = 'paradigm_frequent_emojis'

export function getFrequentEmojis() {
  try {
    return JSON.parse(localStorage.getItem(FREQUENTLY_USED_KEY) || '[]')
  } catch { return [] }
}

export function trackEmojiUsage(emoji) {
  const freq = getFrequentEmojis()
  const updated = [emoji, ...freq.filter(e => e !== emoji)].slice(0, 24)
  localStorage.setItem(FREQUENTLY_USED_KEY, JSON.stringify(updated))
}

/** The emoji drawer as a PURE VIEW: a surface, a search field and a grid.
 *  Dismissal belongs to whoever floats it (a Radix Popover in the message
 *  register, the composer's own portal) — a panel that also decided when to
 *  vanish fought its host, and two dismissals racing is how the reaction
 *  drawer used to close in the frame it opened. */
export default function EmojiPickerPanel({ onSelect }) {
  const searchRef = useRef(null)
  const [search, setSearch] = useState('')
  const [category, setCategory] = useState(null)

  useEffect(() => {
    if (searchRef.current) searchRef.current.focus()
  }, [])

  function handleSelect(emoji) {
    trackEmojiUsage(emoji)
    onSelect(emoji)
  }

  // THE HOUSE'S FLOAT (owner call 2026-10-30: "fits our new ikea / teenage engineering / apple style"): the menu's
  // own frame and surface, one head row (the lens, the field, the shelves as quiet tabs that take colour when chosen),
  // mono kickers over even grids. Search reads every shelf; a chosen shelf, pressed again, opens them all.
  const q = search.trim().toLowerCase()
  const all = Object.values(EMOJI_CATEGORIES).flat()
  const found = q && all.filter((e) => e.includes(q) || EMOJI_NAMES[e]?.some((n) => n.includes(q)))
  const frequent = getFrequentEmojis()
  return (
    <div className="ofself-menu emoji-picker">
      <div className="emoji-picker__head">
        <label className="emoji-picker__search">
          <SearchIcon size={16} />
          <input
            ref={searchRef}
            type="text"
            placeholder="Search emoji"
            aria-label="Search emoji"
            value={search}
            onChange={(e) => { setSearch(e.target.value); setCategory(null) }}
          />
        </label>
        <div className="emoji-picker__cats">
          {Object.keys(EMOJI_CATEGORIES).map((cat) => (
            <Tip key={cat} label={cat}>
              <button type="button" className="emoji-picker__cat" aria-label={cat} aria-pressed={category === cat}
                onClick={() => { setCategory((c) => (c === cat ? null : cat)); setSearch('') }}>
                {CATEGORY_ICONS[cat]}
              </button>
            </Tip>
          ))}
        </div>
      </div>
      <div className="emoji-picker__body">
        {q ? (
          found.length > 0
            ? <Section title="Results" emojis={found} onPick={handleSelect} />
            : <p className="emoji-picker__empty">No emoji found</p>
        ) : category ? (
          <Section title={category} emojis={EMOJI_CATEGORIES[category]} onPick={handleSelect} />
        ) : (
          <>
            {frequent.length > 0 && <Section title="Frequently used" emojis={frequent} onPick={handleSelect} />}
            {Object.entries(EMOJI_CATEGORIES).map(([cat, emojis]) => <Section key={cat} title={cat} emojis={emojis} onPick={handleSelect} />)}
          </>
        )}
      </div>
    </div>
  )
}
